import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'
export default async function (data) {
	const node = data.node;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')


	return {
		"id": id,
		"elements": [
			{
				"type": "text",
				"id": "wjDfSy-n-1",
				"width": 608.38,
				"height": 160.8125,
				"left": 195.81,
				"top": 190.37,
				"rotate": 0,
				"defaultFontName": "Microsoft Yahei",
				"defaultColor": "#333",
				"content": `<p style=\"text-align: center;\"><span style=\"font-size: 140.82px;\"><span style=\"font-family: 微软雅黑;\"><span style=\"color: #ffffff;\">谢谢观看</span></span></span></p>`,
				"lineHeight": 1,
				"outline": {
					"color": "#000",
					"width": 0,
					"style": "solid"
				},
				"fill": "",
				"vertical": false
			},
			{
				"type": "line",
				"id": "b2OFCHDlIo",
				"width": 5,
				"left": 223.55,
				"top": 161.9,
				"start": [
					0,
					0
				],
				"end": [
					558.14,
					0
				],
				"style": "solid",
				"color": "#EDC573",
				"points": [
					"",
					""
				]
			},
			{
				"type": "shape",
				"id": "YQCojUzPed",
				"width": 184.01,
				"height": 56.94,
				"left": 410.62,
				"top": 133.43,
				"viewBox": [
					184.01,
					56.94
				],
				"path": "M 7.1175 0 L 176.89249999999998 0 Q 184.01 0 184.01 7.1175 L 184.01 49.8225 Q 184.01 56.94 176.89249999999998 56.94 L 7.1175 56.94 Q 0 56.94 0 49.8225 L 0 7.1175 Q 0 0 7.1175 0 Z",
				"fill": "#b92034",
				"fixedRatio": false,
				"rotate": 0,
				"outline": {
					"color": "#EDC573",
					"width": 5,
					"style": "solid"
				},
				"text": {
					"content": "<p style=\"text-align: center;\"><span style=\"font-size: 28.57px;\"><span style=\"font-family: 微软雅黑;\"><span style=\"color: rgba(255,255,255,1);\">20XX</span></span></span></p>",
					"defaultFontName": "Microsoft Yahei",
					"defaultColor": "#333",
					"align": "middle"
				},
				"flipH": false,
				"flipV": false,
				"pathFormula": "roundRect",
				"keypoint": 0.125
			},
			{
				"type": "line",
				"id": "JPJ4MojDJD",
				"width": 5,
				"left": 223.55,
				"top": 386.32,
				"start": [
					0,
					0
				],
				"end": [
					558.14,
					0
				],
				"style": "solid",
				"color": "#EDC573",
				"points": [
					"",
					""
				]
			}
		],
		background
	};

}